// Bump when agent-loop / tool-repair behavior changes — visible in Code chat toolbar.
export const AGENT_RUNTIME_VERSION = '2026-06-07-agent-v7';
